<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>اعتماد الانتقال للعام الدراسي الجديد</h2>
            <p>الخطوة الثالثة: بيانات الطالب</p>
        </div>
    </div>
</div>

<div class="service-details ptb-100">
    <div class="container">
        <div class="row align-items-center">




            <div class="">
                <div class="content left-content">
                    <h4>تأكيد وملأ كل بيانات الطالب</h4>
                    <br />


                    <form novalidate autocomplete="off" #form="ngForm">

                        <div class="row">
                            <div class="col-lg-6 col-md-6 form-group">
                                <br />
                                <label>الاسم الثلاثي والقبيلة</label>*
                                <input class="form-control form-control-lg" name="studentName" required
                                       #studentName="ngModel" [(ngModel)]="mainForm.studentName"
                                       [class.invalid]="studentName.invalid && studentName.touched">
                            </div>
                            <div class="col-lg-6 col-md-6 form-group">
                                <br />
                                <label>السنة الدراسية</label>*
                                <select required #mnAcademicYearID="ngModel" disabled name="mnAcademicYearID" [(ngModel)]="mainForm.mnAcademicYearID" class="form-control form-control-lg">
                                    <option *ngFor="let option of AcademicYearData" [value]="option.mnAcademicYearID">{{ option.name }}</option>
                                </select>
                            </div>
                            <div class="col-lg-6 col-md-6 form-group">
                                <br />
                                <label>رقم الهاتف</label>*
                                <input class="form-control form-control-lg" name="phone" required
                                       #phone="ngModel" [(ngModel)]="mainForm.phone" onlyNumber
                                       [class.invalid]="phone.invalid && phone.touched">
                            </div>
                            <div class="col-lg-6 col-md-6 form-group">
                                <br />
                                <label>رقم هاتف آخر</label>
                                <input class="form-control form-control-lg" name="otherPhone"
                                       #otherPhone="ngModel" [(ngModel)]="mainForm.otherPhone" onlyNumber
                                       [class.invalid]="otherPhone.invalid && otherPhone.touched">
                            </div>
                            <div class="col-lg-6 col-md-6 form-group">
                                <br />
                                <label>تاريخ الميلاد</label>*
                                <input type="text" placeholder="DD/MM/YYYY" name="dob"
                                       #dob="ngModel" [(ngModel)]="mainForm.dob"
                                       class="form-control form-control2"
                                       bsDatepicker
                                       [bsValue]="bsValue"
                                       [maxDate]="maxDate"
                                       [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD/MM/YYYY' }">
                            </div>
                            <div class="col-lg-6 col-md-6 form-group">
                                <br />
                                <label>الرقم المدني</label>*
                                <input class="form-control form-control-lg" name="civilID"
                                       #civilID="ngModel" [(ngModel)]="mainForm.civilID"
                                       [class.invalid]="civilID.invalid && civilID.touched">
                            </div>
                            <div class="col-lg-6 col-md-6 form-group">
                                <br />
                                <label>الولاية</label>*
                                <select required #gnAddressID="ngModel" name="gnAddressID" [(ngModel)]="mainForm.gnAddressID" class="form-control form-control-lg">
                                    <option *ngFor="let option of gnAddressData" [value]="option.gnAddressID">{{ option.name }}</option>
                                </select>
                            </div>
                            <div class="col-lg-6 col-md-6 form-group">
                                <br />
                                <label>القرية</label>*
                                <input class="form-control form-control-lg" name="village" required
                                       #village="ngModel" [(ngModel)]="mainForm.village"
                                       [class.invalid]="village.invalid && village.touched">
                            </div>
                            <div class="col-lg-6 col-md-6 form-group">
                                <br />
                                <label>المدرسة</label>*
                                <select required #mnSchoolID="ngModel" name="mnSchoolID" [(ngModel)]="mainForm.mnSchoolID" class="form-control form-control-lg">
                                    <option *ngFor="let option of mnSchoolData" [value]="option.mnSchoolID">{{ option.name }}</option>
                                </select>
                            </div>
                            <div class="col-lg-6 col-md-6 form-group">
                                <br />
                                <label>الصف</label>*
                                <select required #class="ngModel" name="class" value="الخامس" [(ngModel)]="mainForm.class" class="form-control form-control-lg">
                                    <option value="الخامس">الخامس</option>
                                    <option value="السادس">السادس</option>
                                    <option value="السابع">السابع</option>
                                    <option value="الثامن">الثامن</option>
                                    <option value="التاسع">التاسع</option>
                                    <option value="العاشر">العاشر</option>
                                    <option value="الحادي عشر">الحادي عشر</option>
                                    <option value="الثاني عشر">الثاني عشر</option>
                                </select>
                            </div>
                            <div class="col-lg-6 col-md-6 form-group">
                                <br />
                                <label>الشعبة</label>*
                                <select required #room="ngModel" name="room" value="غير محدد" [(ngModel)]="mainFormStudentYear.room" class="form-control form-control-lg">
                                    <option value="غير محدد">غير محدد</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                    <option value="7">7</option>
                                    <option value="8">8</option>
                                    <option value="9">9</option>
                                    <option value="10">10</option>
                                    <option value="11">11</option>
                                    <option value="12">12</option>
                                    <option value="13">13</option>
                                    <option value="14">14</option>
                                    <option value="15">15</option>
                                </select>
                            </div>


                        </div>

                        <hr />

                        <p>

                        </p>
                        <div class="row">
                            <div class="col-lg-12 col-md-12">
                                <div class="form-group mb-3">
                                    <label> وصف موقع السكن أو البيت مع أقرب معلم <span>*</span></label>
                                    <textarea name="accommodationDescription" id="accommodationDescription" #accommodationDescription="ngModel" [(ngModel)]="mainFormStudent.accommodationDescription" class="form-control" placeholder="" required></textarea>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-12 col-md-12">
                                <p class="text-danger">
                                    الرجاء تكرما تحديد الموقع الجغرافي عبر الضغط على زر موقعي الحالي والسماح بتحديد الموقع أو سحب الدبوس لموقع البيت لتسهيل التنسيق مع سائق الحافلة
                                </p>


                                <button class="default-btn" name="locationBtn" (click)="getLocation()">موقعي الحالي</button>


                                <agm-map [latitude]="lat"
                                         [longitude]="lng"
                                         [zoom]="zoom"
                                         [disableDefaultUI]="false"
                                         [zoomControl]="false">

                                    <agm-marker *ngFor="let m of markers; let i = index"
                                                [latitude]="m.lat"
                                                [longitude]="m.lng"
                                                [markerDraggable]="m.draggable"
                                                (dragEnd)="markerDragEnd(m, $event)">

                                        <agm-info-window>
                                            <strong>{{m.label}}</strong>
                                        </agm-info-window>

                                    </agm-marker>


                                </agm-map>
                            </div>

                            <!--<div class="col-lg-6 col-md-6 form-group">
                                <br />
                                <label>خطوط الطول</label>*
                                <input class="form-control form-control-lg" name="longitude" readonly
                                       #longitude="ngModel" [(ngModel)]="mainForm.longitude"
                                       [class.invalid]="longitude.invalid && longitude.touched">
                            </div>
                            <div class="col-lg-6 col-md-6 form-group">
                                <br />
                                <label>خطوط العرض</label>
                                <input class="form-control form-control-lg" name="latitude" readonly
                                       #latitude="ngModel" [(ngModel)]="mainForm.latitude"
                                       [class.invalid]="latitude.invalid && latitude.touched">
                            </div>-->

                        </div>

                        <div class="row">
                            <div class="col-lg-6 col-md-6 form-group">

                                <mat-slide-toggle name="isActiveMap" [(ngModel)]="isActiveMapURL" [checked]="isActiveMapURL">هل تواجه صعوبة في تحديد موقعك؟</mat-slide-toggle>


                            </div>
                        </div>


                        <div class="row" *ngIf="isActiveMapURL">


                            <div class="col-lg-6 col-md-6 form-group">
                                <br />
                                <label>قم بإضافة الرابط لموقعك الجغرافي هنا</label>
                                <input class="form-control form-control-lg" [(ngModel)]="shortUrl" name="shortUrl2">
                            </div>


                            <div class="col-lg-6 col-md-6 form-group">
                                <br />
                                <button type="button" class="default-btn" name="submit_button2" (click)="getFullURL()">الحصول على الموقع</button>
                            </div>
                        </div>


                        <div class="row">
                            <div class="col-lg-12 col-md-12">
                                <br />
                                <br />
                                <button type="button" class="default-btn" name="submit_button" [disabled]="(form.invalid || isDisabled)" (click)="onClickBT()">التالي</button>
                            </div>
                        </div>
                    </form>

                </div>

            </div>
        </div>


    </div>
</div>

